module.exports = __webpack_public_path__ + "static/media/nothing.73fbd983.svg";